import React from "react";

type Tab = {
  id: string;
  label: string;
};

type Props = {
  tabs: Tab[];
  active: string;
  onChange: (id: any) => void;
};

export default function SectionTabs({ tabs, active, onChange }: Props) {
  return (
    <div className="flex gap-1 overflow-x-auto scrollbar-none [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden pb-px">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`relative px-4 py-2.5 text-sm font-medium whitespace-nowrap transition-colors duration-200
            ${
              active === tab.id
                ? "text-neutral-900 dark:text-neutral-100"
                : "text-neutral-400 dark:text-neutral-500 hover:text-neutral-600 dark:hover:text-neutral-300"
            }`}
        >
          {tab.label}
          {active === tab.id && (
            <span className="absolute bottom-0 left-2 right-2 h-0.5 bg-neutral-900 dark:bg-neutral-100 rounded-full" />
          )}
        </button>
      ))}
    </div>
  );
}
